/* unplugin-vue-components disabled */import { render } from "./logoutPage.vue?vue&type=template&id=5d30ce92&scoped=true"
import script from "./logoutPage.vue?vue&type=script&lang=js"
export * from "./logoutPage.vue?vue&type=script&lang=js"

import "./logoutPage.vue?vue&type=style&index=0&id=5d30ce92&lang=less&rel=stylesheet%2Fless&scoped=true"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d30ce92"]])

export default __exports__